import { VAlert } from 'vuetify/lib/components/VAlert';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VRow,{staticClass:"fill-height fill-available",attrs:{"justify":"center","align":"center"}},[_c('div',[_c(VAlert,{attrs:{"outlined":"","color":"primary","icon":"mdi-information"}},[_vm._v(" Coming soon ")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }